import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Badge } from './ui/badge';
import { mockProducts } from '../data/mockProducts';

const ProductCatalog = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'polyester', name: 'Polyester Tapes' },
    { id: 'foam', name: 'Foam Tapes' },
    { id: 'insulation', name: 'Insulation Tapes' },
    { id: 'specialty', name: 'Specialty Tapes' },
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? mockProducts 
    : mockProducts.filter(product => product.category === selectedCategory);

  return (
    <div className="space-y-8">
      {/* Category Filter */}
      <div className="flex flex-wrap gap-3 justify-center">
        {categories.map((category) => (
          <Button
            key={category.id}
            variant={selectedCategory === category.id ? 'default' : 'outline'}
            onClick={() => setSelectedCategory(category.id)}
            className={selectedCategory === category.id ? 'bg-orange-600 hover:bg-orange-700' : 'border-orange-600 text-orange-600 hover:bg-orange-50'}
          >
            {category.name}
          </Button>
        ))}
      </div>

      {/* Products Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredProducts.map((product) => (
          <Card key={product.id} className="hover:shadow-lg transition-shadow border-2 hover:border-orange-200 overflow-hidden">
            {product.image && (
              <div className="w-full h-48 overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            )}
            <CardHeader>
              <div className="flex items-start justify-between mb-2">
                <CardTitle className="text-xl">{product.name}</CardTitle>
                <Badge className="bg-orange-100 text-orange-700 hover:bg-orange-100">
                  {product.code}
                </Badge>
              </div>
              <CardDescription className="text-base">{product.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <Accordion type="single" collapsible className="w-full">
                {product.variants && product.variants.length > 0 && (
                  <AccordionItem value="variants">
                    <AccordionTrigger className="text-sm font-semibold text-orange-600">
                      View Variants ({product.variants.length})
                    </AccordionTrigger>
                    <AccordionContent>
                      <div className="space-y-3">
                        {product.variants.map((variant, index) => (
                          <div key={index} className="bg-gray-50 p-3 rounded-lg">
                            <p className="font-medium text-sm text-gray-900">{variant.name}</p>
                            <p className="text-xs text-gray-600 mt-1">{variant.description}</p>
                          </div>
                        ))}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                )}
                
                {product.features && product.features.length > 0 && (
                  <AccordionItem value="features">
                    <AccordionTrigger className="text-sm font-semibold text-orange-600">
                      Key Features
                    </AccordionTrigger>
                    <AccordionContent>
                      <ul className="space-y-2">
                        {product.features.map((feature, index) => (
                          <li key={index} className="flex items-start">
                            <span className="text-orange-600 mr-2">•</span>
                            <span className="text-sm text-gray-700">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </AccordionContent>
                  </AccordionItem>
                )}
                
                {product.applications && product.applications.length > 0 && (
                  <AccordionItem value="applications">
                    <AccordionTrigger className="text-sm font-semibold text-orange-600">
                      Applications
                    </AccordionTrigger>
                    <AccordionContent>
                      <ul className="space-y-2">
                        {product.applications.map((application, index) => (
                          <li key={index} className="flex items-start">
                            <span className="text-orange-600 mr-2">•</span>
                            <span className="text-sm text-gray-700">{application}</span>
                          </li>
                        ))}
                      </ul>
                    </AccordionContent>
                  </AccordionItem>
                )}
              </Accordion>
              
              <a href="#contact" className="mt-4 block">
                <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white">
                  Request Quote
                </Button>
              </a>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ProductCatalog;